type SortOrder = 'asc' | 'desc';

export function sortData<T>(
  data: T[],
  field: keyof T,
  order: SortOrder = 'asc'
): T[] {
  return [...data].sort((a, b) => {
    const aValue = a[field];
    const bValue = b[field];

    // Push null/undefined values to the bottom
    if (aValue === null || aValue === undefined) return 1;
    if (bValue === null || bValue === undefined) return -1;

    let aComp: string | number | Date = aValue as any;
    let bComp: string | number | Date = bValue as any;

    // Convert dates
    if (
      (typeof aComp === 'string' && !isNaN(Date.parse(aComp))) ||
      aComp instanceof Date
    ) {
      aComp = new Date(aComp);
      bComp = new Date(bComp);
    }

    // Parse numeric-looking strings
    if (!isNaN(Number(aComp)) && !isNaN(Number(bComp))) {
      aComp = Number(aComp);
      bComp = Number(bComp);
    }

    // Case-insensitive string comparison
    if (typeof aComp === 'string' && typeof bComp === 'string') {
      aComp = aComp.toLowerCase();
      bComp = bComp.toLowerCase();
    }

    if (aComp < bComp) return order === 'asc' ? -1 : 1;
    if (aComp > bComp) return order === 'asc' ? 1 : -1;
    return 0;
  });
}